import React from "react";
import { css } from "@emotion/react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { colors, fontSize } from "style";
import Card from "components/Card";
import { Row } from "components/Containers";
import { BUTTON_SIZE, SecondaryButton } from "components/Buttons";

/**
 * AccountValue
 *
 * A saved account value with a button that opens its editor.
 *
 * @param {node}     children  The value to display
 * @param {function} onChange  Called when the user clicks "Change"
 */
const AccountValue = ({ children, onChange }) => (
  <Card xsmallPadding noMargin>
    <Row noWrap gap="1rem" css={styles.row}>
      <span css={styles.value}>{children}</span>

      <SecondaryButton size={BUTTON_SIZE.small} onClick={onChange} css={styles.change}>
        <FormattedMessage id="Global.Change" />
      </SecondaryButton>
    </Row>
  </Card>
);

const styles = {
  row: css`
    justify-content: space-between;
  `,
  value: css`
    font-size: ${fontSize.small};
    font-weight: 500;
    color: ${colors.purpleRainDark2};
    overflow-wrap: anywhere;
  `,
  change: css`
    border: 1px solid ${colors.grayAnatomyLight4};
    box-shadow: none;
  `,
};

AccountValue.propTypes = {
  children: PropTypes.node,
  onChange: PropTypes.func.isRequired,
};

export default AccountValue;
